import { render, staticRenderFns } from "./cascader-widget.vue?vue&type=template&id=3bd43268&scoped=true"
import script from "./cascader-widget.vue?vue&type=script&lang=js"
export * from "./cascader-widget.vue?vue&type=script&lang=js"
import style0 from "./cascader-widget.vue?vue&type=style&index=0&id=3bd43268&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd43268",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd43268')) {
      api.createRecord('3bd43268', component.options)
    } else {
      api.reload('3bd43268', component.options)
    }
    module.hot.accept("./cascader-widget.vue?vue&type=template&id=3bd43268&scoped=true", function () {
      api.rerender('3bd43268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/cascader-widget.vue"
export default component.exports